<div class="navbar-wrapper">
  <nav class="navbar navbar-static-top">
    <div class="d-lg-flex flex-wrap flex-row justify-content-between container">
      <div class="col-lg safescript-gutters">
        <img src="/assets/images/Logo.png" alt="logo" height="45px" />
      </div>
    </div>
  </nav>
</div>
<div class="container-fluid">
  <div style="min-height: 290px; background-color: #fff;">
    <div class="d-lg-flex flex-wrap flex-row container pt-2">
      <div class="col-lg">
      </div>
      <div class="col-lg-6 safescript-gutters">
        <div class="d-flex justify-content-end">
          <a class="qscript-Link pe-22" (click)="support()">Help</a>
        </div>
      </div>
    </div>
    <div class="d-lg-flex flex-wrap flex-row container pt-3">
      <div class="col-lg-6 safescript-gutters">
        <img src="/assets/images/ScriptCheckSA.png" alt="logo" height="100px" />
        <p class="pt-3">
          ScriptCheckSA is a clinical tool providing real-time monitored medicines prescription information for
          prescribers
          and pharmacists to support safer clinical decision-making.
        </p>
      </div>
      <div class="col-lg-6 safescript-gutters">
        <img src="/assets/images/computer-image.png" alt="logo" class="img-fluid" />
      </div>
    </div>
  </div>

  <div class="register-container container position-relative">
    <div class="d-lg-flex flex-wrap flex-row">
      <div class="col-lg-4 safescript-gutters">
        <div class="shadebox justify-content-start">
          <div class="d-lg-flex register-container-header">
            <h4>Health Practitioner Registration</h4>
          </div>
          <div class="d-lg-flex register-container-info">
            <p style="font-style: italic;">
              <span class="wrapText">Eligible AHPRA-registered prescribers and pharmacists can sign-up for
                ScriptCheckSA
                access here.</span>
            </p>
          </div>
          <div class="d-lg-flex justify-content-center">
            <button class="btn btn-lg btn-primary safescript-button" type="button"
              (click)="registrationLogin()">Register</button>
          </div>
        </div>
      </div>

      <div class="col-lg-4 safescript-gutters">
        <div class="shadebox justify-content-start">
          <div class="d-lg-flex register-container-header">
            <h4>Health Practitioner Training </h4>
          </div>
          <div class="d-lg-flex register-container-info">
            <p style="font-style: italic;">
              <span class="wrapText"> Health practitioners can access training and resources here.</span>
            </p>
          </div>
          <div class="d-flex justify-content-between justify-content-lg-around">
            <button class="btn btn-lg btn-primary safescript-button training-button" type="button" (click)="prescriberTraining()"
              style="width: 120px;">Prescribers</button>
            <button class="btn btn-lg btn-primary safescript-button training-button float-right me-2" type="button" (click)="PharmacistTraining()"
              style="width: 120px;">Pharmacists</button>
          </div>
        </div>
      </div>

      <div class="col-lg-4 safescript-gutters">
        <div class="shadebox justify-content-start">
          <div class="d-lg-flex register-container-header">
            <h4>Health Practitioner Login </h4>
          </div>
          <div class="d-lg-flex register-container-info">
            <p style="font-style: italic;">
              <span>Already registered? </span>
              <br />
              <span>
                Log in to access ScriptCheckSA here.
              </span>
            </p>
          </div>
          <div class="d-lg-flex justify-content-center">
            <button class="btn btn-lg btn-primary safescript-button safescript-red-button" type="button"
              (click)="hpLogin()">Login</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="information-container">
    <div class="container pt-4">
      <div class="d-lg-flex flex-wrap">
        <div class="col-lg-12 p-2">
          <div class="d-lg-flex justify-content-center">
            <h4 style="color: #fff;"> I am a patient </h4>
          </div>
          <div class="d-lg-flex justify-content-center">
            <p style="color: #fff;">
              <span class="wrapText">For information for patients relating to ScriptCheckSA, click <a
                  class="patient-Link pe-22"  (click)="qscriptWebsite()">here.</a>
              </span>
              <br>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="support-container pt-3">
    <div class="d-lg-flex flex-wrap container">
      <div class="col-lg-4 supportDiv p-2 justify-content-start">
        <div>
          <i class="fa fa-user-headset faRed">
          </i>
        </div>
        <div class="d-lg-flex pt-1">
          <h4>
            Technical support and general enquiries
          </h4>
        </div>
        <div class="d-lg-flex">
          <p style="color: #212121;">
            <span class="wrapText">1300 652 584
            </span>
            <br>
            <a class="qscript-Link"
              href="mailto:Health.ITsupport.ScriptCheck&#64;sa.gov.au">Health.ITsupport.ScriptCheck&#64;sa.gov.au</a>
          </p>
        </div>
      </div>
      <div class="col-lg-4 supportDiv p-2 justify-content-start">
        <div>
          <i class="fa fa-desktop faRed">
          </i>
        </div>
        <div class="d-lg-flex pt-1">
          <h4> ScriptCheckSA website </h4>
        </div>
        <div class="d-lg-flex">
          <p style="color: #212121;">
            <span class="wrapText">
              For more information, click <a class="qscript-Link" (click)="qscriptWebsite()">here.</a>
            </span>
            <br>
          </p>
        </div>
      </div>
      <div class="col-lg-4 supportDiv p-2 justify-content-start">
        <div>
          <i class="fa fa-wrench faRed">
          </i>
        </div>
        <div class="d-lg-flex pt-1">
          <h4>
            Planned maintenance and updates
          </h4>
        </div>
        <div class="d-lg-flex">
          <app-outtage-message *ngIf="config" [outageText]="config.maintenance"></app-outtage-message>
        </div>
      </div>
    </div>
  </div>
</div>
<footer class="footer-box">

  <div class="container text-center">
    <div class="d-flex justify-content-center">
      <div class="col-md-6 col-7 text-center">
        <a class="safescript-Link me-md-3" (click)="support()">Help</a>
        <a class="safescript-Link ms-3" (click)="accessibility()">Terms & Conditions</a>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="d-flex justify-content-center mt-3 mb-0">
      <div class="col-6 text-center">
        <img src="/assets/images/Logo.png" alt="logo" />
      </div>
    </div>
  </div>

</footer>